const io = require('socket.io-client');

function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

// Export getQueryParams for use in index.jsx
export { getQueryParams };

export default function () {
  const port = process.env.NODE_ENV==='development' ? window.envDevApi : '';

  let params = getQueryParams(document.location.search);
  let id = params.id;
  let name = params.name;
  let token = params.token;
  let room = params.room;
  let action = params.action;
  let adminToken = params.adminToken;

  console.log('id', id, 'room', room, 'action', action);

  // Validate room parameter
  if (!room || room.trim() === '') {
    document.body.innerHTML = '<div class="byebye" style="color: red; padding: 20px; text-align: center;">' +
                              'Error: Room parameter is required. Please provide ?room=ROOM_NAME in the URL.' +
                              '</div>';
    throw new Error('Room parameter is required');
  }

  // Check if stats mode
  if (action === 'stats') {
    const socket = io.connect(port, {
      query: {
        room: room.trim(),
        action: 'stats',
        adminToken: adminToken || ''
      }
    });
    return { isStatsMode: true, socket, roomId: room.trim() };
  }

  const socket = io.connect(port, {
      query: {
        token: token ? token : '',
        name: name,
        id: id,
        p1: params.p1,
        p2: params.p2,
        p3: params.p3,
        room: room.trim()
      }
    });

  socket.on('error', err => {
    console.log('socket error:', err);
    document.querySelector('#root').style.display = 'none';
    document.body.innerHTML = '<div class="byebye" style="color: red; padding: 20px; text-align: center;">' +
                              'Connection Error: ' + (err.message || 'Could not connect to server') +
                              '</div>';
  });
   
  socket.on('turn', (data) => {
    console.log('turn', data);
    window.turn = data;
  });

  socket.on('projectConfig', (data) => {
    console.log('projectConfig received:', data);
    window.projectConfig = data;
    // Create window.lang for backward compatibility with existing code
    window.lang = data.texts || {};
    // Emit event for React components to listen
    window.appEvents.emit('projectConfigReceived', data);
  });

  window.appEvents.on('sendNextQuestion', (toId) => {
    socket.emit('nextQuestion', toId);
  })
  
  socket.on('disconnect', () => {
    document.querySelector('#root').style.display = 'none';
    document.body.innerHTML = '<div class="byebye">You are disconnected</div>';
    //document.location.href = document.location.href;
  })
  
  socket.on('nextQuestion', () => {
    window.appEvents.emit('nextQuestion');
  })
  
  socket.on('noMoreInCouple', () => {
    window.appEvents.emit('noMoreInCouple');
  })

  function getId() {
    return socket.id;
  }

  function registerChatHandler(onMessageReceived, onTyping, onStopTyping) {
    socket.on('message', onMessageReceived);
    socket.on('typing', onTyping);
    socket.on('stop typing', onStopTyping);
  }

  function registerCommonHandler(onConnected, onStrangerDisconnect) {
    socket.on('connected', onConnected);
    socket.on('stranger disconnected', onStrangerDisconnect);
  }

  function registerPeerSignal(onSignal) {
    socket.on('signal', onSignal);
  }

  function registerOnlineUsers(onOnline) {
    socket.on('online', onOnline);
  }

  function unRegisterChatHandler() {
    socket.off('message');
    socket.off('typing');
    socket.off('stop typing');
  }

  function unRegisterCommonHandler() {
    socket.off('connected');
    //socket.off('stranger disconnected');
  }

  function unRegisterPeerSignal(onSignal) {
    socket.off('signal', onSignal);
  }

  function message(msg) {
    socket.emit('message', msg);
  }

  function startTyping(toId) {
    socket.emit('typing', toId);
  }

  function stopTyping(toId) {
    socket.emit('stop typing', toId);
  }

  function startSearch(toId) {
    socket.emit('searching', toId);
  }

  function stop(toId) {
    socket.emit('stop', toId);
  }

  function sendSignal(signal) {
    socket.emit('signal', signal);
  }
  
  async function sendReady() {
    while(!window.turn) {
      await sleep(300);
    }
    console.log('je suis ready');
    socket.emit('ready');
  }
  
  
  function getOnlineUsers(cb) {
    socket.emit('online', cb);
  }
  
  function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

  return {
    getId,
    message,
    registerChatHandler,
    registerCommonHandler,
    registerPeerSignal,
    registerOnlineUsers,
    unRegisterChatHandler,
    unRegisterCommonHandler,
    unRegisterPeerSignal,
    startTyping,
    stopTyping,
    startSearch,
    stop,
    sendSignal,
    getOnlineUsers,
    sendReady
  };
}
